export enum BrokerageStatusEnum {
  Active = 0,
  Suspended = 1,
  Pending = 2,
  Inactive = 3,
  Rejected = 4,
  Offboarded = 5,
  NeedsReview = 6,
}
